import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { notificar } from '../utils/notify';
import '../styles/Relatorio_contabil.css';

const Relatorio_contabil = () => {
  const [dadosEmpresa, setDadosEmpresa] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [mensagem, setMensagem] = useState('');

  useEffect(() => { notificar(mensagem); }, [mensagem]);
  const [erroCarregamento, setErroCarregamento] = useState(false);
  const [abaSelecionada, setAbaSelecionada] = useState('identificacao');
  const [mesesDisponiveis, setMesesDisponiveis] = useState([]);
  const [mesAnoSelecionado, setMesAnoSelecionado] = useState('');
  const [dadosForm, setDadosForm] = useState({
    mensagemAssessor: '',
    tipoMensagem: 'texto_livre',
    clienteNaoAcesso: false,
    retornoClientePendente: false,   // flag "Pendências de retorno do cliente"
    retornoClienteTexto: ''          // o que está faltando o cliente mandar/responder
  });
  
  const [dadosDRE, setDadosDRE] = useState(null);
  const [uploadStatus, setUploadStatus] = useState({
    carregando: false,
    sucesso: false,
    erro: null
  });
  const [arquivoSelecionado, setArquivoSelecionado] = useState(null);
  const [dreEditavel, setDreEditavel] = useState([]);
  
  // Resultado do mês (lucro líquido): é a única linha do DRE que vai no e-mail.
  // Vem preenchido da linha de lucro/prejuízo do DRE até o operador editar.
  const [resultadoMes, setResultadoMes] = useState('');
  const [resultadoMesEditado, setResultadoMesEditado] = useState(false);

  const [statusEntregas, setStatusEntregas] = useState({
    balanceteEntregue: 'concluido',
    registrosFiscais: 'concluido',
    registrosTrabalhistasEncargos: 'concluido',
    conciliacoes: 'concluido'
  });

  const opcoesStatus = [
  { valor: 'concluido', label: 'Concluído', icon: '', iconClass: 'fas fa-check-circle text-success', cor: '#198754' },
  { valor: 'pendente', label: 'Pendente', icon: '', iconClass: 'fas fa-circle text-danger', cor: '#dc3545' },
  { valor: 'nao_se_aplica', label: 'Não se aplica', icon: '', iconClass: 'fas fa-minus text-secondary', cor: '#6c757d' }
];
  const camposStatus = [
    { key: 'balanceteEntregue', label: 'Balancete Entregue' },
    { key: 'registrosFiscais', label: 'Registros Fiscais' },
    { key: 'registrosTrabalhistasEncargos', label: 'Registros Trabalhistas e Encargos' },
    { key: 'conciliacoes', label: 'Conciliações' }
  ];
  
  // Distribuição de lucros por sócio (a chave retiradasSocios segue no payload
  // e no histórico por compatibilidade)
  const [retiradasSocios, setRetiradasSocios] = useState([]);
  
  const [novaRetirada, setNovaRetirada] = useState({
    nomeSocio: '',
    valor: ''
  });
  
  const [pendencias, setPendencias] = useState([]);
  const [novaPendencia, setNovaPendencia] = useState({
    descricao: '',
    gravidade: 'MEDIO',
    relacionadaEntrega: 'Geral (não específica)'
  });
  
  const [mostrarSenhaBI, setMostrarSenhaBI] = useState(false);
  const [mostrarModalConfirmacao, setMostrarModalConfirmacao] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [gerandoMensagem, setGerandoMensagem] = useState(false);
  const [carregandoPreview, setCarregandoPreview] = useState(false);
  const [requerDuploCheck, setRequerDuploCheck] = useState(false);
  // Auditoria em dia é pré-requisito do fechamento (regra da Gestão Contábil)
  const auditoria = dadosEmpresa?.auditoria || null;
  const auditoriaBloqueia = !!(auditoria && auditoria.bloqueia && !dadosForm.clienteNaoAcesso);
  // Simples Nacional nunca auditado: não bloqueia, só avisa
  const auditoriaAvisa = !!(auditoria && !auditoria.bloqueia && auditoria.situacao === 'nunca' && !dadosForm.clienteNaoAcesso);
  const [previewHtml, setPreviewHtml] = useState('');
  const [previewAssunto, setPreviewAssunto] = useState('');
  const [previewDest, setPreviewDest] = useState('');
  const [previewBcc, setPreviewBcc] = useState('');
  // Confirmações POR ETAPA no modal de envio (todas precisam estar marcadas)
  const [confirmacoes, setConfirmacoes] = useState({});
  
  // Endereço do Comece Vision (botões do e-mail e da tela)
  const VISION_URL = process.env.REACT_APP_VISION_URL || 'https://vision.comece.app';
  const VISION_VERSOES = ['Comece Vision', 'Comece Vision Pro', 'Comece Vision Enterprise', 'BI Projeto'];

  // Versão do Comece Vision a partir do cadastro (clientes_contabil.tipo_bi).
  // Mesma regra do backend (_vision_versao): nomes antigos "BI Estratégico (...)"
  // continuam aceitos até o cadastro ser migrado.
  // Qualquer cadastro de BI (BI Projeto, BI Estratégico ...) mostra o card do BI
  // com o link_bi e o nome cadastrado; a versão do Vision só vem de "Comece Vision ...".
  const visionInfo = (tipo_bi) => {
    const t = (tipo_bi || '').trim().toLowerCase();
    if (!t || t === '-' || t === 'nan') return { versao: 'Comece Vision', bi: false, cadastrado: false };
    if (t.startsWith('comece vision')) {
      if (t.includes('enterprise')) return { versao: 'Comece Vision Enterprise', bi: false, cadastrado: true };
      if (t.includes('pro')) return { versao: 'Comece Vision Pro', bi: false, cadastrado: true };
      return { versao: 'Comece Vision', bi: false, cadastrado: true };
    }
    if (t.includes('bi')) return { versao: (tipo_bi || '').trim(), bi: true, cadastrado: true };
    return { versao: 'Comece Vision', bi: false, cadastrado: true };
  };

  // Linha de lucro/prejuízo líquido do DRE (mesma prioridade do backend)
  const detectarResultadoDRE = (linhas) => {
    const norm = (v) => String(v || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
    const prioridades = ['LUCRO LIQUIDO', 'PREJUIZO', 'RESULTADO LIQUIDO', 'RESULTADO DO EXERCICIO', 'RESULTADO DO PERIODO', 'RESULTADO'];
    for (const alvo of prioridades) {
      const linha = linhas.find(l => norm(l.chave).includes(alvo));
      if (linha) return linha;
    }
    return null;
  };

  // Templates atualizados de mensagens
  const templates = [
    { 
      id: 'texto_livre', 
      label: 'Texto Livre',
      texto: '',
      descricao: 'Escreva sua própria mensagem'
    },
    { 
      id: 'desempenho_positivo', 
      label: 'Desempenho Positivo',
      texto: 'Mês com bom desempenho operacional. Recomendamos manter o controle de custos e avaliar novas oportunidades de investimento para o próximo trimestre.',
      icone: '',
      cor: 'success'
    },
    { 
      id: 'pendencias', 
      label: 'Pendências',
      texto: 'Identificamos algumas pendências que precisam de atenção. Por favor, verifique a seção de pendências abaixo e entre em contato caso tenha dúvidas.',
      icone: '',
      cor: 'warning'
    },
    { 
      id: 'mes_estavel', 
      label: 'Mês Estável',
      texto: 'Mês estável com resultados dentro do esperado. Continuamos acompanhando de perto os indicadores financeiros e operacionais.',
      icone: '',
      cor: 'info'
    },
    { 
      id: 'queda_faturamento', 
      label: 'Queda de Faturamento',
      texto: 'Observamos uma queda no faturamento neste período. Sugerimos uma reunião para analisar estratégias de recuperação e ajustes necessários.',
      icone: '',
      cor: 'danger'
    },
    { 
      id: 'performance_excelente', 
      label: 'Performance Excelente',
      texto: 'Excelente performance financeira! A empresa apresentou crescimento significativo e saúde financeira robusta. Parabéns pelo trabalho!',
      icone: '',
      cor: 'success'
    },
    { 
      id: 'urgente_questoes_fiscais', 
      label: 'Urgente - Questões Fiscais',
      texto: 'Importante: há questões fiscais que requerem ação imediata. Entre em contato urgentemente para evitar possíveis complicações.',
      icone: '',
      cor: 'danger'
    }
  ];

  const templatesPendencias = [
    {
      descricao: 'Aguardando documentação complementar do cliente para fechamento completo das notas fiscais de importação',
      gravidade: 'MEDIO',
      relacionadaEntrega: 'Registros Fiscais'
    },
    {
      descricao: 'Divergência identificada no lançamento de horas extras. Necessário ajuste no sistema de ponto eletrônico antes do processamento final',
      gravidade: 'ALTA',
      relacionadaEntrega: 'Trabalhista'
    },
    {
      descricao: 'Recomendável atualização do cadastro de fornecedores para otimizar próximos fechamentos',
      gravidade: 'BAIXA',
      relacionadaEntrega: 'Geral (não específica)'
    }
  ];

  const adicionarTemplatePendencia = (template) => {
    const pendencia = {
      id: Date.now(),
      descricao: template.descricao,
      gravidade: template.gravidade,
      relacionadaEntrega: template.relacionadaEntrega,
      dataCriacao: new Date().toISOString()
    };
    setPendencias(prev => [...prev, pendencia]);
  };

  const opcoesGravidade = [
    { valor: 'BAIXA', label: 'Baixa', icon: '', iconClass: 'fas fa-circle text-success', cor: 'success' },
    { valor: 'MEDIO', label: 'Média', icon: '', iconClass: 'fas fa-circle text-warning', cor: 'warning' },
    { valor: 'ALTA', label: 'Alta', icon: '', iconClass: 'fas fa-circle text-danger', cor: 'danger' }
  ];

  const opcoesRelacionamento = [
    'Geral (não específica)',
    'Documentação',
    'Fiscal',
    'Trabalhista',
    'Financeiro',
    'Societário'
  ];
  
  // Aviso automático de apuração trimestral de IRPJ/CSLL: empresa no Lucro
  // Presumido ou Lucro Real Trimestral E competência de fechamento de
  // trimestre (03, 06, 09, 12). Mesma regra do backend (e-mail).
  const avisoTrimestralAtivo = () => {
    const r = (dadosEmpresa?.regime || '').trim().toLowerCase();
    const regimeTrimestral =
      r.includes('lucro presumido') || r === 'lp' ||
      r.includes('lucro real trimestral') || r === 'lrt';
    if (!regimeTrimestral) return false;
    const mes = parseInt((mesAnoSelecionado || '').split('/')[0], 10);
    return [3, 6, 9, 12].includes(mes);
  };

  // Competências pendentes de processamento: do mês SEGUINTE à última entrega
  // (que já foi feita) até o mês anterior ao mês atual. Mesma regra do
  // backend (e-mail). Devolve [] se a última entrega não for interpretável.
  const competenciasPendentes = () => {
    const d = parseDataEntrega(dadosEmpresa?.ultima_entrega);
    if (!d) return [];
    const hoje = new Date();
    const fim = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);
    const lista = [];
    const atual = new Date(d.getFullYear(), d.getMonth() + 1, 1);
    while (atual <= fim && lista.length < 36) {
      lista.push(formatarCompetenciaMMAAAA(atual));
      atual.setMonth(atual.getMonth() + 1);
    }
    return lista;
  };

  const abrirLinkBI = () => {
    if (dadosEmpresa?.link_bi) {
      window.open(dadosEmpresa.link_bi, '_blank', 'noopener,noreferrer');
    }
  };

  const copiarSenhaBI = () => {
    if (dadosEmpresa?.senha_bi) {
      navigator.clipboard.writeText(dadosEmpresa.senha_bi)
        .then(() => {
          alert('Senha copiada para a área de transferência!');
        })
        .catch(err => {
          console.error('Erro ao copiar senha: ', err);
        });
    }
  };

  const formatarValorMonetario = (valor) => {
    if (!valor) return '';
    const numeros = valor.replace(/\D/g, '');
    const valorNumerico = parseFloat(numeros) / 100;
    return valorNumerico.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const parseDreValor = (valor) => {
    if (typeof valor === 'number') return valor;
    const str = String(valor).trim().replace(/\./g, '').replace(',', '.');
    return parseFloat(str) || 0;
  };

  // Renderiza a mensagem do assessor IGUAL ao e-mail: **negrito** vira <strong>
  // e cada linha vira um parágrafo justificado.
  const renderMensagemFormatada = (texto) => {
    if (!texto) return null;
    return texto.split('\n').filter(l => l.trim()).map((linha, i) => {
      const partes = linha.split('**');
      return (
        <p key={i} style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#333', lineHeight: 1.6, textAlign: 'justify' }}>
          {partes.map((p, j) => (j % 2 === 1 ? <strong key={j}>{p}</strong> : p))}
        </p>
      );
    });
  };

  const formatarValorDRE = (input) => {
    const str = String(input).trim();
    const isNegative = str.includes('-');
    const digits = str.replace(/\D/g, '');
    if (!digits) return isNegative ? '-' : '';
    const numero = parseInt(digits, 10) / 100;
    const formatted = numero.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return isNegative ? `-${formatted}` : formatted;
  };

  // Preenche o resultado do mês a partir do DRE enquanto o operador não editar
  useEffect(() => {
    if (resultadoMesEditado) return;
    const linha = detectarResultadoDRE(dreEditavel);
    setResultadoMes(linha ? linha.valor : '');
  }, [dreEditavel, resultadoMesEditado]); // eslint-disable-line react-hooks/exhaustive-deps

  // FUNÇÕES PARA RETIRADAS DE SÓCIOS
  const adicionarRetirada = () => {
    if (!novaRetirada.nomeSocio.trim()) {
      alert('Por favor, informe o nome do sócio.');
      return;
    }
    
    if (!novaRetirada.valor || novaRetirada.valor === '0') {
      alert('Por favor, informe um valor válido.');
      return;
    }
    
    const retirada = {
      id: Date.now(),
      nomeSocio: novaRetirada.nomeSocio,
      valor: novaRetirada.valor
    };
    
    setRetiradasSocios([...retiradasSocios, retirada]);
    setNovaRetirada({ nomeSocio: '', valor: '' });
  };
  
  const removerRetirada = (id) => {
    setRetiradasSocios(retiradasSocios.filter(r => r.id !== id));
  };
  
  const calcularTotalRetiradas = () => {
    return retiradasSocios.reduce((total, item) => {
      const valorNumerico = parseFloat((item.valor || '0').replace(/\D/g, '')) / 100;
      return total + valorNumerico;
    }, 0);
  };

  useEffect(() => {
    const carregarDadosEmpresa = async () => {
      try {
        const dadosArmazenados = JSON.parse(localStorage.getItem('relatorio_empresa') || '{}');
        
        // código 0 é válido (== null cobre undefined/null, não o zero)
        if (dadosArmazenados.numero_dominio == null || dadosArmazenados.numero_dominio === '') {
          throw new Error('Nenhuma empresa selecionada para gerar relatório.');
        }
        
        const accessToken = localStorage.getItem('access');
        
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE}/api/relatorio-contabil/${dadosArmazenados.numero_dominio}/`,
          {
            headers: { 
              'Authorization': `Bearer ${accessToken}`,
              'Content-Type': 'application/json'
            },
            timeout: 10000
          }
        );
        
        if (response.data.success && response.data.empresa) {
          setDadosEmpresa(response.data.empresa);
          const meses = gerarMesesDisponiveis(
            response.data.empresa.ultima_entrega,
            response.data.empresa.ultimo_relatorio,
            response.data.empresa.competencias_enviadas
          );
          setMesesDisponiveis(meses);
          // Padrão = próxima competência a enviar (a mais antiga sem relatório após o
          // último envio); sem histórico, a da última entrega; senão, a primeira
          const dataEnt = parseDataEntrega(response.data.empresa.ultima_entrega);
          if (meses.proximoEnviar) {
            setMesAnoSelecionado(meses.proximoEnviar);
          } else if (dataEnt) {
            setMesAnoSelecionado(formatarCompetenciaMMAAAA(dataEnt));
          } else if (meses.length > 0) {
            setMesAnoSelecionado(meses[0].valor);
          }
          setCarregando(false);
        } else {
          throw new Error(response.data.mensagem || 'Não foi possível encontrar os dados da empresa');
        }
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
        let mensagemErro = 'Erro ao carregar dados da empresa';
        
        if (error.response) {
          mensagemErro = error.response.data.mensagem || `Erro ${error.response.status}: ${error.response.statusText}`;
        } else if (error.request) {
          mensagemErro = 'Sem resposta do servidor. Verifique sua conexão de internet.';
        } else if (error.message) {
          mensagemErro = error.message;
        }
        
        setMensagem(mensagemErro);
        setErroCarregamento(true);
        setCarregando(false);
      }
    };
    
    carregarDadosEmpresa();
  }, []);

  // Competência no formato MM/AAAA (ex: 05/2026)
  const formatarCompetenciaMMAAAA = (date) => {
    const mes = (date.getMonth() + 1).toString().padStart(2, '0');
    return `${mes}/${date.getFullYear()}`;
  };

  // Converte a última entrega (vários formatos) em Date. Retorna null se inválida.
  const parseDataEntrega = (dataUltimaEntrega) => {
    if (!dataUltimaEntrega) return null;
    const s = String(dataUltimaEntrega).trim();
    try {
      // "YYYY-MM-DD" ou "YYYY-MM" (com ou sem hora)
      if (s.includes('-')) {
        const dataPart = s.split(' ')[0];
        const [ano, mes, dia] = dataPart.split('-');
        const d = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia || '1'));
        return isNaN(d.getTime()) ? null : d;
      }
      if (s.includes('/')) {
        const partes = s.split('/');
        // "MM/YY" ou "MM/YYYY" (competência)
        if (partes.length === 2) {
          let ano = parseInt(partes[1]);
          if (ano < 100) ano = ano < 50 ? 2000 + ano : 1900 + ano;
          const d = new Date(ano, parseInt(partes[0]) - 1, 1);
          return isNaN(d.getTime()) ? null : d;
        }
        // "DD/MM/YYYY"
        if (partes.length === 3) {
          const d = new Date(parseInt(partes[2]), parseInt(partes[1]) - 1, parseInt(partes[0]));
          return isNaN(d.getTime()) ? null : d;
        }
      }
    } catch (error) {
      console.error('Erro ao processar data da última entrega:', error);
    }
    return null;
  };

  // Competências oferecidas no relatório.
  //
  // Regra: do mês seguinte ao ÚLTIMO RELATÓRIO ENVIADO até o mês atual — assim
  // toda competência pendente aparece. Antes a lista era fixa (atual, anterior,
  // última entrega e 4 meses para trás) e um cliente com relatório parado em
  // 03/2026 nunca via 04/2026 para enviar.
  // Sem histórico de envio, cai no comportamento antigo (janela de 4 meses).
  // A janela é limitada a 24 meses para a lista não virar um rolo.
  const gerarMesesDisponiveis = (dataUltimaEntrega, ultimoRelatorio, competenciasEnviadas = []) => {
    const hoje = new Date();
    const atual = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
    const anterior = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);
    const dataEntrega = parseDataEntrega(dataUltimaEntrega);
    const mesEntrega = dataEntrega ? formatarCompetenciaMMAAAA(dataEntrega) : null;
    const enviadas = new Set(competenciasEnviadas || []);

    const parseMMAAAA = (s) => {
      const m = /^(\d{2})\/(\d{4})$/.exec(String(s || '').trim());
      return m ? new Date(parseInt(m[2], 10), parseInt(m[1], 10) - 1, 1) : null;
    };

    // início da janela: mês seguinte ao último relatório enviado
    let inicio = null;
    const dataUltimoRel = parseMMAAAA(ultimoRelatorio);
    if (dataUltimoRel) {
      inicio = new Date(dataUltimoRel.getFullYear(), dataUltimoRel.getMonth() + 1, 1);
    } else {
      inicio = new Date(hoje.getFullYear(), hoje.getMonth() - 4, 1);
    }
    // nunca menos de 24 meses atrás, nunca depois do mês anterior
    const limite = new Date(hoje.getFullYear(), hoje.getMonth() - 24, 1);
    if (inicio < limite) inicio = limite;
    if (inicio > anterior) inicio = anterior;

    // "Última Entrega" é o último FECHAMENTO registrado; "Próximo a enviar" é a
    // competência mais antiga ainda sem relatório depois do último envio. São
    // coisas diferentes: fechamento 06/2026 com relatório parado em 03/2026
    // significa que o próximo a enviar é 04/2026, não 06.
    // calculado a partir do último relatório, e não do início da janela (que é
    // limitado ao mês anterior só para a lista nunca ficar vazia); nunca passa
    // do mês atual
    let proximoEnviar = mesEntrega;
    if (dataUltimoRel) {
      const seguinte = new Date(dataUltimoRel.getFullYear(), dataUltimoRel.getMonth() + 1, 1);
      proximoEnviar = formatarCompetenciaMMAAAA(seguinte > atual ? atual : seguinte);
    }
    const rotulo = (d) => {
      const valor = formatarCompetenciaMMAAAA(d);
      const tags = [];
      if (valor === formatarCompetenciaMMAAAA(atual)) tags.push('Atual');
      if (valor === formatarCompetenciaMMAAAA(anterior)) tags.push('Mês Anterior');
      if (mesEntrega && valor === mesEntrega) tags.push('Última Entrega (fechamento)');
      if (proximoEnviar && valor === proximoEnviar) {
        tags.push(dataUltimoRel
          ? `Próximo a enviar — último relatório foi ${ultimoRelatorio}`
          : 'Próximo a enviar');
      }
      if (enviadas.has(valor)) tags.push('já enviado');
      return { valor, label: tags.length ? `${valor} (${tags.join(' · ')})` : valor };
    };

    const meses = [];
    const vistos = new Set();
    const empurrar = (d) => {
      const item = rotulo(d);
      if (!vistos.has(item.valor)) { vistos.add(item.valor); meses.push(item); }
    };

    // do mais recente para o mais antigo, como a lista sempre foi
    for (let d = new Date(atual); d >= inicio; d = new Date(d.getFullYear(), d.getMonth() - 1, 1)) {
      empurrar(d);
    }
    // a competência da última entrega entra mesmo fora da janela
    if (dataEntrega) empurrar(new Date(dataEntrega.getFullYear(), dataEntrega.getMonth(), 1));

    // a tela seleciona o próximo a enviar por padrão
    meses.proximoEnviar = proximoEnviar;
    return meses;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setDadosForm({
      ...dadosForm,
      [name]: type === 'checkbox' ? checked : value
    });
  };
  
  const selecionarTemplate = (templateId) => {
    const template = templates.find(t => t.id === templateId);
    if (template) {
      setDadosForm({
        ...dadosForm,
        tipoMensagem: templateId,
        mensagemAssessor: template.texto
      });
    }
  };
  
  const adicionarPendencia = () => {
    if (!novaPendencia.descricao.trim()) {
      alert('Por favor, descreva a pendência.');
      return;
    }
    
    const pendencia = {
      id: Date.now(),
      descricao: novaPendencia.descricao,
      gravidade: novaPendencia.gravidade,
      relacionadaEntrega: novaPendencia.relacionadaEntrega,
      dataCriacao: new Date().toISOString()
    };
    
    setPendencias([...pendencias, pendencia]);
    setNovaPendencia({
      descricao: '',
      gravidade: 'MEDIO',
      relacionadaEntrega: 'Geral (não específica)'
    });
  };
  
  const removerPendencia = (id) => {
    setPendencias(pendencias.filter(p => p.id !== id));
  };
  
  const handlePendenciaChange = (campo, valor) => {
    setNovaPendencia({
      ...novaPendencia,
      [campo]: valor
    });
  };
  
  const handleUploadDRE = async (event) => {
    const arquivo = event.target.files[0];
    
    if (!arquivo) return;
    
    if (arquivo.type !== 'application/pdf') {
      setUploadStatus({
        carregando: false,
        sucesso: false,
        erro: 'Apenas arquivos PDF são permitidos'
      });
      return;
    }
    
    if (arquivo.size > 10 * 1024 * 1024) {
      setUploadStatus({
        carregando: false,
        sucesso: false,
        erro: 'O arquivo não pode ter mais de 10MB'
      });
      return;
    }
    
    setArquivoSelecionado(arquivo);
    setUploadStatus({ carregando: true, sucesso: false, erro: null });
    
    try {
      const formData = new FormData();
      formData.append('dre', arquivo);
      formData.append('numero_dominio', dadosEmpresa.numero_dominio);
      formData.append('mes_ano', mesAnoSelecionado);
      
      const accessToken = localStorage.getItem('access');
      
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/upload-dre/`,
        formData,
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      
      if (response.data.sucesso) {
        setDadosDRE(response.data);
        const linhasEditaveis = Object.entries(response.data.dados_dre).map(([chave, valor], index) => ({
          id: `${Date.now()}_${index}`,
          chave,
          valor: typeof valor === 'number' ? valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : String(valor),
          negrito: false
        }));
        setDreEditavel(linhasEditaveis);
        setUploadStatus({
          carregando: false,
          sucesso: true,
          erro: null
        });
      }
    } catch (error) {
      console.error('Erro ao fazer upload:', error);
      setUploadStatus({
        carregando: false,
        sucesso: false,
        erro: error.response?.data?.erro || 'Erro ao processar o arquivo'
      });
    }
  };

  const removerDRE = () => {
    setDadosDRE(null);
    setDreEditavel([]);
    setArquivoSelecionado(null);
    setUploadStatus({ carregando: false, sucesso: false, erro: null });
    const inputFile = document.getElementById('upload_dre');
    if (inputFile) inputFile.value = '';
  };

  const baixarPDF = () => {
    alert('Funcionalidade de download do PDF será implementada em breve.');
  };
  
  // Payload único usado tanto na prévia quanto no envio — garante que o que o
  // operador vê no modal é exatamente o que gera o e-mail.
  const montarPayload = () => ({
    numero_dominio: dadosEmpresa.numero_dominio,
    mes_ano: mesAnoSelecionado,
    mensagem_assessor: dadosForm.mensagemAssessor,
    dados_dre: dreEditavel
      .filter(linha => linha.chave.trim())
      .map(linha => ({
        chave: linha.chave,
        valor: parseDreValor(linha.valor),
        negrito: linha.negrito || false
      })),
    // só o resultado do mês vai no e-mail; o DRE inteiro fica no histórico
    resultado_mes: resultadoMes.trim() ? parseDreValor(resultadoMes) : null,
    posicao_financeira: {
      bancos: 0,
      aplicacoes: 0,
      retiradasSocios: retiradasSocios.map(item => ({
        nomeSocio: item.nomeSocio,
        valor: parseFloat((item.valor || '0').replace(/\D/g, '')) / 100
      }))
    },
    pendencias: pendencias,
    status_entregas: statusEntregas,
    cliente_nao_acesso: dadosForm.clienteNaoAcesso,
    retorno_cliente: dadosForm.retornoClientePendente ? dadosForm.retornoClienteTexto.trim() : ''
  });

  // Abre o modal e busca a PRÉVIA REAL do e-mail (mesmo HTML que o cliente recebe)
  const enviarRelatorio = async () => {
    if (auditoriaBloqueia) {
      alert(`⚠️ Envio bloqueado: auditoria pendente.\n\n${auditoria.mensagem}`);
      return;
    }
    if (!dadosEmpresa?.email_socio) {
      alert('E-mail do sócio não cadastrado. Não é possível enviar o relatório.');
      return;
    }
    if (!mesAnoSelecionado) {
      alert('Selecione o período de referência.');
      return;
    }
    if (dadosForm.retornoClientePendente && !dadosForm.retornoClienteTexto.trim()) {
      alert('Descreva o que está faltando em "Pendências de retorno do cliente" ou desmarque a opção.');
      return;
    }
    setConfirmacoes({});
    setPreviewHtml('');
    setPreviewAssunto('');
    setPreviewDest('');
    setPreviewBcc('');
    setMostrarModalConfirmacao(true);
    setCarregandoPreview(true);

    try {
      const accessToken = localStorage.getItem('access');
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/enviar-relatorio/`,
        { ...montarPayload(), preview: true },
        { headers: { 'Authorization': `Bearer ${accessToken}`, 'Content-Type': 'application/json' }, timeout: 60000 }
      );
      if (response.data.sucesso) {
        setPreviewHtml(response.data.html || '');
        setPreviewAssunto(response.data.assunto || '');
        setPreviewDest(response.data.destinatario || '');
        setRequerDuploCheck(!!response.data.requer_duplo_check);
        setPreviewBcc(response.data.bcc || '');
      } else {
        alert(response.data.erro || 'Não foi possível gerar a prévia do e-mail.');
        setMostrarModalConfirmacao(false);
      }
    } catch (error) {
      console.error('Erro ao gerar prévia:', error);
      alert(error.response?.data?.erro || 'Erro ao gerar a prévia do e-mail.');
      setMostrarModalConfirmacao(false);
    } finally {
      setCarregandoPreview(false);
    }
  };

  const confirmarEnvio = async () => {
    setEnviando(true);
    setMensagem('Enviando relatório...');

    try {
      const accessToken = localStorage.getItem('access');

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/enviar-relatorio/`,
        montarPayload(),
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data.sucesso) {
        setMostrarModalConfirmacao(false);
        if (response.data.em_revisao) {
          alert(`🕒 ${response.data.mensagem}`);
          setMensagem('Relatório enviado para revisão — aguardando aprovação de um administrador.');
        } else {
          alert(`${response.data.mensagem}`);
          setMensagem('Relatório enviado com sucesso!');
        }
      }
    } catch (error) {
      console.error('Erro ao enviar relatório:', error);
      const mensagemErro = error.response?.data?.erro || 'Erro ao enviar relatório';
      alert(error.response?.data?.codigo === 'auditoria_pendente'
        ? `⚠️ Envio bloqueado: auditoria pendente.\n\n${mensagemErro}`
        : `${mensagemErro}`);
      setMensagem('');
    } finally {
      setEnviando(false);
    }
  };

  // Gera a "Mensagem do Assessor" via IA (Claude Fable) a partir do DRE + posição
  // financeira. Preenche o textarea como RASCUNHO editável — o operador revisa.
  const gerarMensagemIA = async () => {
    if (dreEditavel.length === 0) {
      alert('Faça o upload do DRE (aba DRE) antes de gerar a mensagem.');
      return;
    }
    setGerandoMensagem(true);
    setMensagem('Gerando rascunho da mensagem... pode levar alguns segundos.');
    try {
      const accessToken = localStorage.getItem('access');
      const payload = {
        numero_dominio: dadosEmpresa.numero_dominio,
        empresa: dadosEmpresa.empresa,
        mes_ano: mesAnoSelecionado,
        dados_dre: dreEditavel
          .filter(l => l.chave.trim())
          .map(l => ({ chave: l.chave, valor: parseDreValor(l.valor) })),
        posicao_financeira: {
          bancos: 0,
          aplicacoes: 0,
          retiradasSocios: retiradasSocios.map(item => ({
            nomeSocio: item.nomeSocio,
            valor: parseFloat((item.valor || '0').replace(/\D/g, '')) / 100
          }))
        }
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/gerar-mensagem-assessor/`,
        payload,
        { headers: { 'Authorization': `Bearer ${accessToken}`, 'Content-Type': 'application/json' }, timeout: 420000 }
      );
      if (response.data.sucesso) {
        setDadosForm(prev => ({ ...prev, tipoMensagem: 'texto_livre', mensagemAssessor: response.data.mensagem }));
        setMensagem(response.data.comparou_anterior
          ? 'Rascunho gerado (comparando com o mês anterior). Revise antes de enviar.'
          : 'Rascunho gerado. Revise antes de enviar.');
      } else {
        setMensagem('');
        alert(response.data.erro || 'Não foi possível gerar a mensagem.');
      }
    } catch (error) {
      console.error('Erro ao gerar mensagem:', error);
      setMensagem('');
      alert(error.response?.data?.erro || 'Erro ao gerar a mensagem. Tente novamente ou escreva manualmente.');
    } finally {
      setGerandoMensagem(false);
    }
  };

  // Etapas que o operador precisa confirmar no modal, conforme o conteúdo
  // do relatório. Quando o cliente não dá acesso, o e-mail só tem o aviso
  // e a mensagem — as demais seções nem são enviadas.
  const itensConfirmacao = dadosForm.clienteNaoAcesso
    ? [
        { key: 'aviso', label: 'Aviso de processamento impossibilitado e competências pendentes conferidos' },
        ...(dadosForm.mensagemAssessor.trim() ? [{ key: 'mensagem', label: 'Mensagem do Assessor revisada' }] : [])
      ]
    : [
        ...(resultadoMes.trim() ? [{ key: 'dre', label: `Resultado do mês — R$ ${resultadoMes} conferido com o DRE` }] : []),
        ...(retiradasSocios.length > 0 ? [{ key: 'posicao', label: `Distribuição de lucros — ${retiradasSocios.length} sócio(s) e valores conferidos` }] : []),
        { key: 'status', label: 'Status das Entregas conferido' },
        {
          key: 'pendencias',
          label: pendencias.length > 0
            ? `Pendências — ${pendencias.length} cadastrada(s), textos e gravidades conferidos`
            : 'Pendências — nenhuma cadastrada (correto para este mês)'
        },
        ...(dadosForm.mensagemAssessor.trim() ? [{ key: 'mensagem', label: 'Mensagem do Assessor revisada' }] : [])
      ];
  if (dadosForm.retornoClientePendente && dadosForm.retornoClienteTexto.trim()) {
    itensConfirmacao.push({ key: 'retorno_cliente', label: 'Pendências de retorno do cliente — texto conferido' });
  }
  const todasConfirmadas = itensConfirmacao.every(item => confirmacoes[item.key]);

  if (carregando) {
    return (
      <div className="container mt-5 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Carregando...</span>
        </div>
        <p className="mt-3">Carregando dados da empresa...</p>
      </div>
    );
  }

  if (erroCarregamento) {
    return (
      <div className="container mt-5">
        <div className="alert alert-danger" role="alert">
          <i className="fas fa-exclamation-circle me-2"></i>
          {mensagem || 'Ocorreu um erro ao carregar os dados da empresa.'}
        </div>
        <button 
          className="btn btn-outline-primary"
          onClick={() => window.history.back()}
        >
          <i className="fas fa-arrow-left me-2"></i>
          Voltar
        </button>
      </div>
    );
  }

  return (
    <div className="relatorio-contabil-page">
      {/* MODAL DE CONFIRMAÇÃO DE ENVIO */}
      {mostrarModalConfirmacao && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: 'rgba(0,0,0,0.55)' }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
            <div className="modal-content">
              <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
                <h5 className="modal-title mb-0 fw-bold" style={{ color: '#212529' }}>
                  <i className="fas fa-paper-plane me-2"></i>
                  Confirmar Envio do Relatório
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setMostrarModalConfirmacao(false)}
                  disabled={enviando}
                ></button>
              </div>

              <div className="modal-body" style={{ background: '#f0f2f5' }}>
                {/* ALERTA IA — DRE */}
                {dreEditavel.length > 0 && (
                  <div
                    className="mb-3 p-3 rounded-3"
                    style={{
                      background: 'linear-gradient(135deg, #7f1d1d 0%, #b91c1c 100%)',
                      border: '2px solid #991b1b',
                      boxShadow: '0 4px 15px rgba(185,28,28,0.4)',
                    }}
                  >
                    <div className="d-flex align-items-center gap-3 mb-2">
                      <div
                        style={{
                          backgroundColor: 'rgba(255,255,255,0.15)',
                          borderRadius: '50%',
                          width: '48px',
                          height: '48px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0,
                        }}
                      >
                        <i className="fas fa-robot text-white fs-4"></i>
                      </div>
                      <div>
                        <div className="text-white fw-bold fs-6">
                          <i className="fas fa-exclamation-triangle text-warning me-2"></i>ATENÇÃO — DRE LIDO POR INTELIGÊNCIA ARTIFICIAL
                        </div>
                        <div className="text-white-50" style={{ fontSize: '0.72rem', letterSpacing: '0.05em' }}>
                          REVISÃO OBRIGATÓRIA ANTES DO ENVIO
                        </div>
                      </div>
                    </div>
                    <div className="rounded-2 px-3 py-2" style={{ backgroundColor: 'rgba(0,0,0,0.25)' }}>
                      <p className="mb-0 text-white" style={{ fontSize: '0.875rem', lineHeight: '1.5' }}>
                        Os dados do DRE foram extraídos automaticamente por IA e{' '}
                        <strong className="text-white">podem conter erros de leitura</strong>.
                        Revise cada nomenclatura e valor na prévia abaixo antes de confirmar o envio ao cliente.
                      </p>
                    </div>
                  </div>
                )}

                {/* Cabeçalho estilo e-mail: Para / Assunto */}
                <div className="mb-3 p-3 rounded bg-white border">
                  <div className="mb-1">
                    <span className="text-muted" style={{ width: '80px', display: 'inline-block' }}>Para:</span>
                    <strong>{previewDest || dadosEmpresa?.email_socio || '—'}</strong>
                  </div>
                  <div className={previewBcc ? 'mb-1' : ''}>
                    <span className="text-muted" style={{ width: '80px', display: 'inline-block' }}>Assunto:</span>
                    <strong>{previewAssunto || '—'}</strong>
                  </div>
                  {previewBcc && (
                    <div>
                      <span className="text-muted" style={{ width: '80px', display: 'inline-block' }}>Cco:</span>
                      <strong>{previewBcc}</strong>
                    </div>
                  )}
                </div>

                <p className="text-muted small mb-2">
                  <i className="fas fa-eye me-1"></i>
                  Esta é a prévia real do e-mail — exatamente como o cliente vai receber.
                </p>

                {carregandoPreview ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status"></div>
                    <p className="mt-3 text-muted">Gerando prévia do e-mail...</p>
                  </div>
                ) : (
                  <iframe
                    title="Prévia do e-mail"
                    srcDoc={previewHtml}
                    sandbox="allow-same-origin"
                    style={{ width: '100%', height: '65vh', border: '1px solid #e7e9ee', borderRadius: '8px', background: '#ffffff' }}
                  />
                )}
              </div>

              <div className="modal-footer flex-column align-items-stretch gap-2">
                {requerDuploCheck && (
                  <div
                    className="w-100 p-3 rounded-3 mb-0 d-flex align-items-center gap-2"
                    style={{ backgroundColor: '#e7f3ff', border: '2px solid #2B6CB0' }}
                  >
                    <i className="fas fa-user-shield fs-5" style={{ color: '#2B6CB0' }}></i>
                    <span style={{ fontSize: '0.85rem', color: '#1A365D' }}>
                      <strong>Este cliente passa por duplo check:</strong> ao confirmar, o relatório{' '}
                      <u>não será enviado imediatamente</u> — ele ficará pendente de revisão e só será
                      disparado após a aprovação de um administrador.
                    </span>
                  </div>
                )}
                <div
                  className="w-100 p-3 rounded-3"
                  style={{
                    backgroundColor: todasConfirmadas ? '#d1fae5' : '#fff3cd',
                    border: `2px solid ${todasConfirmadas ? '#059669' : '#d97706'}`,
                    transition: 'all 0.2s ease',
                  }}
                >
                  <p className="fw-bold mb-2" style={{ fontSize: '0.9rem', color: todasConfirmadas ? '#065f46' : '#92400e' }}>
                    {todasConfirmadas
                      ? <><i className="fas fa-check-circle text-success me-1"></i>Todas as etapas conferidas — pronto para enviar</>
                      : `Confirme cada etapa revisada na prévia acima (${itensConfirmacao.filter(i => confirmacoes[i.key]).length}/${itensConfirmacao.length}):`}
                  </p>
                  {itensConfirmacao.map(item => (
                    <label
                      key={item.key}
                      className="d-flex align-items-center gap-2 mb-1"
                      style={{ cursor: enviando ? 'not-allowed' : 'pointer' }}
                    >
                      <input
                        type="checkbox"
                        checked={!!confirmacoes[item.key]}
                        onChange={() => setConfirmacoes(prev => ({ ...prev, [item.key]: !prev[item.key] }))}
                        disabled={enviando}
                        style={{ width: '17px', height: '17px', flexShrink: 0, cursor: enviando ? 'not-allowed' : 'pointer' }}
                      />
                      <span style={{
                        fontSize: '0.83rem',
                        color: confirmacoes[item.key] ? '#065f46' : '#664d03',
                        fontWeight: confirmacoes[item.key] ? 600 : 400
                      }}>
                        {confirmacoes[item.key] ? '✓ ' : ''}{item.label}
                      </span>
                    </label>
                  ))}
                </div>

                <div className="d-flex gap-2 justify-content-end">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => setMostrarModalConfirmacao(false)}
                    disabled={enviando}
                  >
                    <i className="fas fa-arrow-left me-2"></i>
                    Voltar e Revisar
                  </button>
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={confirmarEnvio}
                    disabled={enviando || carregandoPreview || !previewHtml || !todasConfirmadas || auditoriaBloqueia}
                    title={!previewHtml ? 'Aguarde a prévia do e-mail carregar' : (!todasConfirmadas ? 'Confirme todas as etapas antes de enviar' : '')}
                    style={{ opacity: (todasConfirmadas && previewHtml) ? 1 : 0.5 }}
                  >
                    {enviando ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                        Enviando...
                      </>
                    ) : requerDuploCheck ? (
                      <>
                        <i className="fas fa-user-shield me-2"></i>
                        Enviar para Revisão
                      </>
                    ) : (
                      <>
                        <i className="fas fa-paper-plane me-2"></i>
                        Confirmar Envio
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="container-fluid py-3">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div className="d-flex align-items-center">
            <i className="fas fa-file-invoice header-icon fs-1 me-3"></i>
            <div>
              <h2 className="titulo-pagina mb-0">Comece - Relatório Contábil</h2>
              <p className="text-muted mb-0">Gerador de Fechamento Mensal</p>
            </div>
          </div>
          <button className="btn btn-primary" onClick={baixarPDF}>
            <i className="fas fa-download me-2"></i>
            Baixar PDF
          </button>
        </div>
        
        <div className="row">
          <div className="col-lg-7 mb-4">
            <div className="card shadow-sm">
              <div className="card-header bg-light">
                <h5 className="mb-0">Dados do Relatório</h5>
              </div>
              <div className="card-body">
                {/* Auditoria: aviso no topo para o operador ver antes de preencher */}
                {auditoriaBloqueia && (
                  <div className="alert alert-danger d-flex align-items-start mb-4" role="alert">
                    <i className="fas fa-balance-scale me-3 mt-1" style={{ fontSize: '1.2rem' }}></i>
                    <div>
                      <strong className="d-block mb-1">
                        Envio bloqueado: {auditoria.situacao === 'nunca' ? 'empresa nunca auditada' : 'auditoria vencida'}
                      </strong>
                      <span className="small">{auditoria.mensagem}</span>
                    </div>
                  </div>
                )}
                {auditoriaAvisa && (
                  <div className="alert alert-warning d-flex align-items-start mb-4" role="alert">
                    <i className="fas fa-balance-scale me-3 mt-1" style={{ fontSize: '1.2rem' }}></i>
                    <span className="small">{auditoria.mensagem}</span>
                  </div>
                )}
                <ul className="nav nav-tabs mb-4">
                  <li className="nav-item">
                    <a 
                      className={`nav-link ${abaSelecionada === 'identificacao' ? 'active' : ''}`}
                      href="#identificacao"
                      onClick={(e) => {
                        e.preventDefault();
                        setAbaSelecionada('identificacao');
                      }}
                    >
                      Identificação
                    </a>
                  </li>
                  <li className="nav-item">
                    <a 
                      className={`nav-link ${abaSelecionada === 'dre' ? 'active' : ''}`}
                      href="#dre"
                      onClick={(e) => {
                        e.preventDefault();
                        setAbaSelecionada('dre');
                      }}
                    >
                      DRE
                    </a>
                  </li>
                  <li className="nav-item">
                    <a 
                      className={`nav-link ${abaSelecionada === 'posicao' ? 'active' : ''}`}
                      href="#posicao"
                      onClick={(e) => {
                        e.preventDefault();
                        setAbaSelecionada('posicao');
                      }}
                    >
                      Distribuição de Lucros
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link ${abaSelecionada === 'status' ? 'active' : ''}`}
                      href="#status"
                      onClick={(e) => {
                        e.preventDefault();
                        setAbaSelecionada('status');
                      }}
                    >
                      Status
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link ${abaSelecionada === 'pendencias' ? 'active' : ''}`}
                      href="#pendencias"
                      onClick={(e) => {
                        e.preventDefault();
                        setAbaSelecionada('pendencias');
                      }}
                    >
                      Pendências
                    </a>
                  </li>
                  <li className="nav-item">
                    <a 
                      className={`nav-link ${abaSelecionada === 'bi' ? 'active' : ''}`}
                      href="#bi"
                      onClick={(e) => {
                        e.preventDefault();
                        setAbaSelecionada('bi');
                      }}
                    >
                      Comece Vision
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link ${abaSelecionada === 'mensagem' ? 'active' : ''}`}
                      href="#mensagem"
                      onClick={(e) => {
                        e.preventDefault();
                        setAbaSelecionada('mensagem');
                      }}
                    >
                      Mensagem do Assessor
                    </a>
                  </li>
                </ul>
                
                {abaSelecionada === 'identificacao' && (
                  <div id="identificacao">
                    {/* CONTEÚDO IDENTIFICAÇÃO - MANTÉM IGUAL */}
                    <form>
                      <div className="mb-3">
                        <label htmlFor="nome_empresa" className="form-label">Nome da Empresa</label>
                        <input
                          type="text"
                          className="form-control"
                          id="nome_empresa"
                          value={dadosEmpresa?.empresa || ''}
                          readOnly
                        />
                      </div>

                      <div className="mb-3">
                        <label htmlFor="regime_tributario" className="form-label">Regime Tributário</label>
                        <input
                          type="text"
                          className="form-control"
                          id="regime_tributario"
                          value={dadosEmpresa?.regime || 'Não cadastrado'}
                          readOnly
                        />
                        {avisoTrimestralAtivo() && (
                          <small className="form-text d-block" style={{ color: '#2B6CB0' }}>
                            <i className="fas fa-info-circle me-1"></i>
                            Competência de fechamento de trimestre — o e-mail incluirá automaticamente
                            o aviso de apuração trimestral de IRPJ e CSLL.
                          </small>
                        )}
                      </div>


                      <div className="form-check mb-3 border p-3 rounded bg-light">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="cliente_nao_acesso"
                          name="clienteNaoAcesso"
                          checked={dadosForm.clienteNaoAcesso}
                          onChange={handleInputChange}
                        />
                        <label className="form-check-label text-danger" htmlFor="cliente_nao_acesso">
                          Cliente não dá acesso aos dados financeiros
                        </label>
                        <div className="small text-muted mt-1">
                          Ao marcar esta opção, o relatório destacará que o processamento contábil não pode ser realizado.
                        </div>
                      </div>

                      <div className="form-check mb-3 border p-3 rounded bg-light">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="retorno_cliente_pendente"
                          name="retornoClientePendente"
                          checked={dadosForm.retornoClientePendente}
                          onChange={handleInputChange}
                        />
                        <label className="form-check-label fw-semibold" htmlFor="retorno_cliente_pendente" style={{ color: '#b45309' }}>
                          Pendências de retorno do cliente
                        </label>
                        <div className="small text-muted mt-1">
                          Marque quando faltar algo do cliente (documento, extrato, resposta). O texto vai em destaque no e-mail.
                        </div>
                        {dadosForm.retornoClientePendente && (
                          <div className="mt-2">
                            <label htmlFor="retorno_cliente_texto" className="form-label small fw-semibold mb-1">
                              O que está faltando?
                            </label>
                            <textarea
                              id="retorno_cliente_texto"
                              name="retornoClienteTexto"
                              className={`form-control ${!dadosForm.retornoClienteTexto.trim() ? 'is-invalid' : ''}`}
                              rows={4}
                              maxLength={4000}
                              placeholder="Ex.: extrato bancário de agosto; notas fiscais de entrada da semana 3; resposta sobre o lançamento de R$ 1.200,00"
                              value={dadosForm.retornoClienteTexto}
                              onChange={handleInputChange}
                            />
                            {!dadosForm.retornoClienteTexto.trim() && (
                              <div className="invalid-feedback">Descreva o que falta para poder enviar.</div>
                            )}
                          </div>
                        )}
                      </div>
                      
                      <div className="mb-3">
                        <label htmlFor="mes_ano" className="form-label">Mês/Ano (Competência)</label>
                        <select
                          className="form-select"
                          id="mes_ano"
                          value={mesAnoSelecionado}
                          onChange={(e) => setMesAnoSelecionado(e.target.value)}
                        >
                          {mesesDisponiveis.map((mes, index) => (
                            <option key={index} value={mes.valor}>
                              {mes.label}
                            </option>
                          ))}
                        </select>
                        <small className="form-text d-block fw-bold" style={{ color: '#dc3545' }}>
                          * Atenção a qual mês é este relatório!
                        </small>
                        <small className="form-text text-muted">
                          Selecione o período de referência para o relatório.
                        </small>
                      </div>
                      
                      <div className="mb-3">
                        <label htmlFor="assessor" className="form-label">Operador Responsável</label>
                        <input
                          type="text"
                          className="form-control"
                          id="assessor"
                          value={[dadosEmpresa?.operador, dadosEmpresa?.sobrenome_operador].filter(Boolean).join(' ')}
                          readOnly
                        />
                      </div>
                      
                      <div className="mb-3">
                        <label htmlFor="email_assessor" className="form-label">E-mail do Operador</label>
                        <input
                          type="email"
                          className="form-control"
                          id="email_assessor"
                          value={dadosEmpresa?.email_operador || dadosEmpresa?.email_assessor || ''}
                          readOnly
                        />
                      </div>
                      
                      <div className="mb-3">
                        <label htmlFor="agenda_assessor" className="form-label">Link de Agenda do operador</label>
                        <input
                          type="url"
                          className="form-control"
                          id="agenda_assessor"
                          value={dadosEmpresa?.agenda_operador || ''}
                          readOnly
                        />
                        {dadosEmpresa?.agenda_operador && (
                          <div className="mt-2">
                            <a 
                              href={dadosEmpresa.agenda_operador} 
                              target="_blank" 
                              rel="noopener noreferrer"
                              className="btn btn-sm btn-outline-primary"
                            >
                              <i className="fas fa-calendar-alt me-2"></i>
                              Abrir agenda do assessor
                            </a>
                          </div>
                        )}
                      </div>
                      
                      <div className="card mb-3 border-info">
                        <div 
                          className="card-header bg-white"
                        >
                          <i className="fas fa-user me-2"></i>
                          Dados do Sócio para Envio
                        </div>
                        <div className="card-body">
                          <div className="mb-3">
                            <label htmlFor="nome_socio" className="form-label">Nome do Sócio</label>
                            <input
                              type="text"
                              className="form-control"
                              id="nome_socio"
                              value={dadosEmpresa?.nome_socio || ''}
                              readOnly
                            />
                          </div>
                          
                          <div className="mb-3">
                            <label htmlFor="email_socio" className="form-label">E-mail do Sócio</label>
                            <input
                              type="email"
                              className="form-control"
                              id="email_socio"
                              value={dadosEmpresa?.email_socio || ''}
                              readOnly
                            />
                          </div>
                          
                          {(!dadosEmpresa?.nome_socio || !dadosEmpresa?.email_socio) && (
                            <div className="alert alert-warning mb-0">
                              <i className="fas fa-exclamation-triangle me-2"></i>
                              Dados do sócio incompletos. Entre em contato com o administrador para atualização.
                            </div>
                          )}
                        </div>
                      </div>
                    </form>
                  </div>
                )}
                
                {abaSelecionada === 'dre' && (
                  <div id="dre">
                    {/* No e-mail vai só o resultado do mês; o DRE completo fica no histórico e alimenta a IA */}
                    <div className="card border-0 shadow-sm mb-4">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
                          <label htmlFor="resultado_mes" className="form-label fw-bold mb-0">
                            <i className="fas fa-chart-line me-2" style={{ color: '#04c2d7' }}></i>
                            Resultado do mês (lucro líquido)
                          </label>
                          {resultadoMesEditado && (
                            <button
                              type="button"
                              className="btn btn-link btn-sm p-0"
                              onClick={() => setResultadoMesEditado(false)}
                            >
                              voltar ao valor do DRE
                            </button>
                          )}
                        </div>
                        <div className="input-group">
                          <span className="input-group-text">R$</span>
                          <input
                            type="text"
                            id="resultado_mes"
                            className="form-control form-control-lg text-end"
                            placeholder="0,00"
                            value={resultadoMes}
                            onChange={(e) => { setResultadoMesEditado(true); setResultadoMes(formatarValorDRE(e.target.value)); }}
                            style={{ fontWeight: 600, color: resultadoMes.startsWith('-') ? '#c1153d' : '#196640' }}
                          />
                        </div>
                        <small className="text-muted d-block mt-2">
                          É o único número do DRE que vai no e-mail. Ele é preenchido com a linha de
                          lucro/prejuízo líquido do DRE enviado; use valor negativo para prejuízo.
                        </small>
                      </div>
                    </div>

                    <div className="mb-4">
                      <h5 className="mb-3">
                        <i className="fas fa-file-upload me-2"></i>
                        Upload do DRE
                      </h5>
                      
                      {!dadosDRE ? (
                        <div className="card border-2 border-dashed">
                          <div className="card-body text-center py-5">
                            <i className="fas fa-cloud-upload-alt fa-3x text-muted mb-3"></i>
                            <div className="mb-3">
                              <label htmlFor="upload_dre" className="btn btn-primary">
                                <i className="fas fa-upload me-2"></i>
                                Selecionar DRE (PDF)
                              </label>
                              <input
                                type="file"
                                id="upload_dre"
                                className="d-none"
                                accept=".pdf"
                                onChange={handleUploadDRE}
                              />
                            </div>
                            <p className="text-muted mb-0">
                              Arraste e solte ou clique para selecionar o arquivo PDF do DRE
                            </p>
                            <small className="text-muted">Tamanho máximo: 10MB</small>
                          </div>
                        </div>
                      ) : (
                        <div className="card border-success">
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <div>
                                <h6 className="mb-1">
                                  <i className="fas fa-check-circle text-success me-2"></i>
                                  DRE carregado com sucesso
                                </h6>
                                <small className="text-muted">
                                  {arquivoSelecionado?.name} - {mesAnoSelecionado}
                                </small>
                              </div>
                              <button 
                                className="btn btn-sm btn-outline-danger"
                                onClick={removerDRE}
                              >
                                <i className="fas fa-trash me-1"></i>
                                Remover
                              </button>
                            </div>
                            <div className="alert alert-info mb-0">
                              <i className="fas fa-info-circle me-2"></i>
                              {dreEditavel.length} linha(s) lidas pela IA ({dadosDRE.total_campos_encontrados} de {dadosDRE.total_campos_esperados} campos esperados).
                              Elas preenchem o resultado do mês acima e alimentam a mensagem do assessor — no e-mail vai só o resultado do mês.
                            </div>
                          </div>
                        </div>
                      )}
                      
                      {uploadStatus.carregando && (
                        <div className="alert alert-info mt-3">
                          <div className="d-flex align-items-center">
                            <div className="spinner-border spinner-border-sm me-2" role="status">
                              <span className="visually-hidden">Carregando...</span>
                            </div>
                            <span>Processando DRE...</span>
                          </div>
                        </div>
                      )}
                      
                      {uploadStatus.erro && (
                        <div className="alert alert-danger mt-3">
                          <i className="fas fa-exclamation-triangle me-2"></i>
                          {uploadStatus.erro}
                        </div>
                      )}
                    </div>
                    
                  </div>
                )}
                
                {abaSelecionada === 'posicao' && (
                  <div id="posicao">
                    <div className="mb-4">
                      <h5 className="mb-1">
                        <i className="fas fa-hand-holding-usd me-2"></i>
                        Distribuição de Lucros
                      </h5>
                      <p className="text-muted small mb-4">
                        Informe os valores distribuídos a cada sócio no mês. Se não houver distribuição, deixe em branco — o bloco não aparece no e-mail.
                      </p>

                      <div className="card border-0 shadow-sm mb-4">
                        <div className="card-header bg-white">
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center">
                              <i className="fas fa-users fs-5 me-2" style={{ color: '#1d2530' }}></i>
                              <h6 className="mb-0 fw-bold">Sócios</h6>
                            </div>
                            <span className="badge" style={{ backgroundColor: '#1d2530', color: 'white' }}>
                              Total: R$ {calcularTotalRetiradas().toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                            </span>
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="row g-2 mb-3">
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Nome do sócio"
                                value={novaRetirada.nomeSocio}
                                onChange={(e) => setNovaRetirada({ ...novaRetirada, nomeSocio: e.target.value })}
                              />
                            </div>
                            <div className="col-md-4">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="R$ 0,00"
                                value={novaRetirada.valor ? `R$ ${formatarValorMonetario(novaRetirada.valor)}` : ''}
                                onChange={(e) => setNovaRetirada({ ...novaRetirada, valor: e.target.value.replace(/\D/g, '') })}
                              />
                            </div>
                            <div className="col-md-2">
                              <button className="btn btn-success w-100" onClick={adicionarRetirada}>
                                <i className="fas fa-plus"></i>
                              </button>
                            </div>
                          </div>

                          {retiradasSocios.length > 0 ? (
                            <div className="list-group">
                              {retiradasSocios.map(item => (
                                <div key={item.id} className="list-group-item d-flex justify-content-between align-items-center">
                                  <strong>{item.nomeSocio}</strong>
                                  <div className="d-flex align-items-center">
                                    <span className="me-3 fw-bold">R$ {formatarValorMonetario(item.valor)}</span>
                                    <button className="btn btn-sm btn-outline-danger" onClick={() => removerRetirada(item.id)}>
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="alert alert-light mb-0 text-center">
                              <i className="fas fa-info-circle me-2"></i>
                              Nenhuma distribuição cadastrada
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {abaSelecionada === 'status' && (
                  <div id="status">
                    <div className="mb-4">
                      <h5 className="mb-1">Status das Entregas</h5>
                      <p className="text-muted small mb-4">Informe o status de cada entrega do fechamento contábil</p>

                      <div className="row g-3 mb-4">
                        {camposStatus.map(campo => {
                          const statusAtual = opcoesStatus.find(o => o.valor === statusEntregas[campo.key]);
                          return (
                            <div className="col-md-6" key={campo.key}>
                              <div className="card border-0 shadow-sm h-100">
                                <div className="card-body">
                                  <label className="form-label fw-bold mb-2">{campo.label}</label>
                                  <div className="input-group">
                                    <span className="input-group-text bg-white" style={{ fontSize: '1.1rem' }}>
                                      {statusAtual && <i className={statusAtual.iconClass}></i>}
                                    </span>
                                    <select
                                      className="form-select"
                                      value={statusEntregas[campo.key]}
                                      onChange={(e) => setStatusEntregas({ ...statusEntregas, [campo.key]: e.target.value })}
                                      style={{ color: statusAtual?.cor, fontWeight: '600' }}
                                    >
                                      {opcoesStatus.map(opcao => (
                                        <option key={opcao.valor} value={opcao.valor}>
                                          {opcao.icon} {opcao.label}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>

                    </div>
                  </div>
                )}

                {/* CONTINUA NO PRÓXIMO BLOCO... */}

{abaSelecionada === 'pendencias' && (
                  <div id="pendencias">
                    <div className="mb-4">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <div>
                          <h5 className="mb-1">Pendências Identificadas</h5>
                          <p className="text-muted small mb-0">Registre pendências com seu grau de gravidade</p>
                        </div>
                      </div>

                      {/* Templates rápidos */}
                      <div className="mb-4">
                        <p className="text-muted small fw-bold mb-2">Sugestões rápidas — clique para adicionar:</p>
                        {templatesPendencias.map((t, i) => {
                          const gravConfig = { BAIXA: { cor: '#198754', bg: '#d1e7dd', label: 'BAIXO' }, MEDIO: { cor: '#997404', bg: '#fff3cd', label: 'MÉDIO' }, ALTA: { cor: '#842029', bg: '#f8d7da', label: 'ALTO' } };
                          const g = gravConfig[t.gravidade];
                          return (
                            <div
                              key={i}
                              className="mb-2 p-3 rounded"
                              style={{ backgroundColor: g.bg, border: `1px solid ${g.cor}33`, cursor: 'pointer' }}
                              onClick={() => adicionarTemplatePendencia(t)}
                            >
                              <div className="d-flex justify-content-between align-items-start">
                                <span className="small">{t.descricao}</span>
                                <span className="badge ms-3 text-nowrap" style={{ backgroundColor: g.bg, color: g.cor, border: `1px solid ${g.cor}`, borderRadius: '20px', fontSize: '11px' }}>
                                  ● {g.label}
                                </span>
                              </div>
                              {t.relacionadaEntrega !== 'Geral (não específica)' && (
                                <div className="mt-1" style={{ fontSize: '11px', color: '#6c757d' }}>
                                  <i className="fas fa-clipboard-list me-1"></i>Relacionada a: {t.relacionadaEntrega}
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>

                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <div>
                          <p className="text-muted small mb-0">Ou adicione manualmente:</p>
                        </div>
                        <button 
                          className="btn btn-primary btn-sm"
                          onClick={adicionarPendencia}
                        >
                          <i className="fas fa-plus me-2"></i>
                          Adicionar Pendência
                        </button>
                      </div>
                      
                      <div className="card border-primary mb-4">
                        <div className="card-body">
                          <div className="mb-3">
                            <label htmlFor="descricao_pendencia" className="form-label">Descrição da Pendência</label>
                            <textarea
                              className="form-control"
                              id="descricao_pendencia"
                              rows="3"
                              placeholder="Descreva a pendência identificada..."
                              value={novaPendencia.descricao}
                              onChange={(e) => handlePendenciaChange('descricao', e.target.value)}
                            ></textarea>
                          </div>
                          
                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <label htmlFor="gravidade" className="form-label">Grau de Gravidade</label>
                              <select
                                className="form-select"
                                id="gravidade"
                                value={novaPendencia.gravidade}
                                onChange={(e) => handlePendenciaChange('gravidade', e.target.value)}
                              >
                                {opcoesGravidade.map(opcao => (
                                  <option key={opcao.valor} value={opcao.valor}>
                                    {opcao.icon} {opcao.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                            
                            <div className="col-md-6 mb-3">
                              <label htmlFor="relacionada" className="form-label">Relacionada à Entrega</label>
                              <select
                                className="form-select"
                                id="relacionada"
                                value={novaPendencia.relacionadaEntrega}
                                onChange={(e) => handlePendenciaChange('relacionadaEntrega', e.target.value)}
                              >
                                {opcoesRelacionamento.map((opcao, index) => (
                                  <option key={index} value={opcao}>
                                    {opcao}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      {pendencias.length > 0 && (
                        <div>
                          <h6 className="mb-3">Pendências Cadastradas ({pendencias.length})</h6>
                          {pendencias.map(pendencia => {
                            const gravidade = opcoesGravidade.find(g => g.valor === pendencia.gravidade);
                            return (
                              <div key={pendencia.id} className={`card mb-3 border-${gravidade.cor}`}>
                                <div className="card-body">
                                  <div className="d-flex justify-content-between align-items-start">
                                    <div className="flex-grow-1">
                                      <div className="d-flex align-items-center mb-2">
                                        <i className={`${gravidade.iconClass} me-2`}></i>
                                        <span className={`badge bg-${gravidade.cor} me-2`}>
                                          {gravidade.label}
                                        </span>
                                        <span className="badge bg-secondary">
                                          {pendencia.relacionadaEntrega}
                                        </span>
                                      </div>
                                      <p className="mb-0">{pendencia.descricao}</p>
                                    </div>
                                    <button
                                      className="btn btn-sm btn-outline-danger ms-3"
                                      onClick={() => removerPendencia(pendencia.id)}
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                      
                      {pendencias.length === 0 && (
                        <div className="alert alert-info text-center">
                          <i className="fas fa-info-circle me-2"></i>
                          Nenhuma pendência cadastrada ainda. Use o formulário acima para adicionar.
                        </div>
                      )}
                    </div>
                  </div>
                )}
                
                {abaSelecionada === 'bi' && (
                  <div id="bi">
                    {(() => {
                      const info = visionInfo(dadosEmpresa?.tipo_bi);
                      return (
                        <>
                          <div className="alert alert-info mb-4">
                            <i className="fas fa-info-circle me-2"></i>
                            <strong>Versão cadastrada:</strong>{' '}
                            <span className="badge ms-1" style={{ backgroundColor: '#1d2530' }}>{info.versao}</span>
                            {!info.cadastrado && (
                              <span className="text-muted ms-2 small">(sem versão no cadastro — o e-mail usa "Comece Vision")</span>
                            )}
                            {dadosEmpresa?.tipo_bi && !info.bi && !VISION_VERSOES.includes(dadosEmpresa.tipo_bi) && (
                              <div className="small text-muted mt-1">
                                Cadastro ainda com o nome antigo "{dadosEmpresa.tipo_bi}". Atualize na Contabilidade quando puder.
                              </div>
                            )}
                          </div>

                          <div className="card border-0 shadow-sm mb-4" style={{ background: '#1d2530' }}>
                            <div className="card-body py-4">
                              <div className="d-flex align-items-center gap-3 mb-3">
                                <i className="fas fa-rocket fa-2x text-white"></i>
                                <div>
                                  <h6 className="fw-bold text-white mb-1">{info.bi ? 'Comece Vision' : info.versao}</h6>
                                  <p className="small mb-0" style={{ color: '#b4c2cf' }}>
                                    O e-mail abre com o fechamento e leva o cliente ao Comece Vision — a mensagem do assessor vai resumida com "ver mais".
                                  </p>
                                </div>
                              </div>
                              <a className="btn btn-sm fw-bold" style={{ backgroundColor: '#04c2d7', color: '#1d2530' }} href={VISION_URL} target="_blank" rel="noopener noreferrer">
                                <i className="fas fa-external-link-alt me-2"></i>
                                Abrir o Comece Vision
                              </a>
                            </div>
                          </div>

                          {info.bi && (
                            <div className="card border-0 shadow-sm">
                              <div className="card-header bg-white">
                                <i className="fas fa-chart-bar me-2" style={{ color: '#f1be48' }}></i>
                                <strong>{info.versao}</strong>
                                <span className="text-muted small ms-2">o e-mail inclui o card do BI com este link</span>
                              </div>
                              <div className="card-body">
                                {dadosEmpresa?.link_bi ? (
                                  <>
                                    <div className="mb-3">
                                      <label className="form-label fw-bold">
                                        <i className="fas fa-link me-2 text-primary"></i>Link do dashboard
                                      </label>
                                      <div className="input-group">
                                        <input type="text" className="form-control" value={dadosEmpresa.link_bi} readOnly />
                                        <button className="btn btn-primary" type="button" onClick={abrirLinkBI} title="Abrir link">
                                          <i className="fas fa-external-link-alt"></i>
                                        </button>
                                      </div>
                                    </div>
                                    <div className="mb-0">
                                      <label className="form-label fw-bold">
                                        <i className="fas fa-lock me-2 text-secondary"></i>Senha de acesso
                                      </label>
                                      <div className="input-group">
                                        <input type={mostrarSenhaBI ? 'text' : 'password'} className="form-control" value={dadosEmpresa.senha_bi || 'N/A'} readOnly />
                                        <button className="btn btn-outline-secondary" type="button" onClick={() => setMostrarSenhaBI(!mostrarSenhaBI)}>
                                          <i className={`fas fa-eye${mostrarSenhaBI ? '-slash' : ''}`}></i>
                                        </button>
                                        <button className="btn btn-outline-primary" type="button" onClick={copiarSenhaBI} disabled={!dadosEmpresa.senha_bi}>
                                          <i className="fas fa-copy"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <div className="alert alert-warning mb-0">
                                    <i className="fas fa-exclamation-triangle me-2"></i>
                                    <strong>Link do BI não cadastrado.</strong> O e-mail vai sem o link — peça a atualização ao administrador.
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </>
                      );
                    })()}
                  </div>
                )}

                {abaSelecionada === 'mensagem' && (
                  <div id="mensagem">
                    <div className="mb-4">
                      <h5 className="mb-1">Mensagem do Assessor</h5>
                      <p className="text-muted small mb-3">
                        Preencha o DRE, a distribuição de lucros e os demais dados nas outras abas.
                        Depois gere um rascunho com base nesses números e revise antes de enviar.
                        No e-mail a mensagem sai resumida: as primeiras <strong>55 palavras</strong> e um
                        "ver mais" que leva ao Comece Vision.
                      </p>

                      <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
                        <button
                          className="btn btn-primary"
                          onClick={gerarMensagemIA}
                          disabled={gerandoMensagem || dreEditavel.length === 0}
                          title={dreEditavel.length === 0 ? 'Faça o upload do DRE primeiro' : ''}
                        >
                          {gerandoMensagem ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                              Gerando mensagem...
                            </>
                          ) : (
                            <>
                              <i className="fas fa-comment-dots me-2"></i>
                              Gerar mensagem com IA
                            </>
                          )}
                        </button>
                        {dreEditavel.length === 0 && (
                          <small className="text-danger">
                            <i className="fas fa-exclamation-triangle me-1"></i>
                            Faça o upload do DRE (aba DRE) antes de gerar.
                          </small>
                        )}
                      </div>

                      <div className="alert alert-warning py-2 small">
                        <i className="fas fa-pen me-2"></i>
                        O texto é um <strong>rascunho</strong>. Leia com atenção, confira se cada número
                        tem nexo com o fechamento e ajuste o que precisar — você é responsável pela
                        mensagem enviada ao cliente.
                      </div>

                      <div className="mb-3">
                        <label htmlFor="tipo_mensagem" className="form-label">Ou use um modelo pronto</label>
                        <select
                          className="form-select mb-2"
                          id="tipo_mensagem"
                          value={dadosForm.tipoMensagem}
                          onChange={(e) => selecionarTemplate(e.target.value)}
                        >
                          {templates.map(template => (
                            <option key={template.id} value={template.id}>
                              {template.icone ? `${template.icone} ` : ''}{template.label}
                            </option>
                          ))}
                        </select>

                        {dadosForm.tipoMensagem !== 'texto_livre' && (
                          <div className={`alert alert-${templates.find(t => t.id === dadosForm.tipoMensagem)?.cor || 'info'} py-2 mb-2`}>
                            <small>
                              <i className="fas fa-info-circle me-2"></i>
                              <strong>Prévia:</strong> {templates.find(t => t.id === dadosForm.tipoMensagem)?.texto}
                            </small>
                          </div>
                        )}

                        <label htmlFor="mensagem_assessor" className="form-label d-flex justify-content-between">
                          <span>Mensagem (edite à vontade)</span>
                          {(() => {
                            const n = dadosForm.mensagemAssessor.trim() ? dadosForm.mensagemAssessor.trim().split(/\s+/).length : 0;
                            return (
                              <small className={n > 55 ? 'text-warning' : 'text-muted'}>
                                {n} palavra(s){n > 55 ? ' — no e-mail vão as 55 primeiras + "ver mais"' : ''}
                              </small>
                            );
                          })()}
                        </label>
                        <textarea
                          className="form-control"
                          id="mensagem_assessor"
                          name="mensagemAssessor"
                          rows="14"
                          maxLength={10000}
                          value={dadosForm.mensagemAssessor}
                          onChange={handleInputChange}
                          placeholder="Gere um rascunho com o botão acima ou escreva manualmente..."
                        ></textarea>
                      </div>
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>

          {/* COLUNA DE PREVIEW */}
          <div className="col-lg-5">
            <div className="card shadow-sm">
              <div className="card-header bg-light">
                <h5 className="mb-0">Prévia do Relatório</h5>
              </div>
              <div className="card-body">
                <div className="preview-container p-3 border rounded bg-white">
                  <div className="bg- text-black p-3 rounded mb-3">
                    <h6 className="mb-1">Fechamento Contábil — {mesAnoSelecionado}</h6>
                    <p className="mb-1 small">{dadosEmpresa?.empresa}</p>
                    <p className="mb-1 small">
                      <i className="fas fa-user me-1"></i>
                      Assessor: {dadosEmpresa?.operador}
                    </p>
                  </div>
                  
                  {/* Preview aviso cliente sem acesso */}
                  {dadosForm.clienteNaoAcesso && (
                    <div className="mb-3" style={{
                      border: '2px solid #dc3545',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      fontFamily: 'Arial, sans-serif'
                    }}>
                      <div style={{
                        backgroundColor: '#fff3cd',
                        borderBottom: '2px solid #dc3545',
                        padding: '10px 14px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                      }}>
                        <i className="fas fa-exclamation-triangle" style={{ color: '#842029', fontSize: '1.1rem' }}></i>
                        <strong style={{ color: '#842029', fontSize: '0.88rem' }}>
                          ATENÇÃO: Processamento Contábil Impossibilitado
                        </strong>
                      </div>
                      <div style={{ backgroundColor: '#fff5f5', padding: '12px 14px' }}>
                        {(() => {
                          const dUltima = parseDataEntrega(dadosEmpresa?.ultima_entrega);
                          const pend = competenciasPendentes();
                          const lista = pend.length > 0 ? pend : [mesAnoSelecionado];
                          return (
                            <>
                              {dUltima && (
                                <p style={{ color: '#555', marginBottom: '8px', fontSize: '0.82rem', textAlign: 'left' }}>
                                  Sua última entrega foi <strong>{formatarCompetenciaMMAAAA(dUltima)}</strong>.
                                </p>
                              )}
                              <p style={{ color: '#555', marginBottom: '8px', fontSize: '0.82rem', textAlign: 'left' }}>
                                O processamento contábil {lista.length > 1 ? 'dos períodos abaixo' : 'do período abaixo'}{' '}
                                não pode ser realizado devido à{' '}
                                <u>ausência de acesso às informações financeiras</u>:
                              </p>
                              <ul style={{ margin: '0 0 10px 0', paddingLeft: '20px', textAlign: 'left' }}>
                                {lista.map(c => (
                                  <li key={c} style={{ color: '#dc3545', fontWeight: 'bold', fontSize: '0.82rem', margin: '2px 0' }}>
                                    {c}
                                  </li>
                                ))}
                              </ul>
                            </>
                          );
                        })()}
                        <div style={{
                          backgroundColor: '#dc3545',
                          borderRadius: '6px',
                          padding: '10px 12px',
                          marginBottom: dadosEmpresa?.agenda_operador ? '10px' : '0'
                        }}>
                          <p style={{ color: 'white', fontWeight: 'bold', marginBottom: '4px', fontSize: '0.78rem' }}>
                            AÇÃO NECESSÁRIA:
                          </p>
                          <p style={{ color: 'white', marginBottom: 0, fontSize: '0.78rem', lineHeight: '1.5' }}>
                            É IMPRESCINDÍVEL QUE SEJA FEITO O CONTATO <strong>URGENTE</strong> COM O SEU ASSESSOR para regularizar o acesso aos dados e possibilitar a
                            continuidade dos serviços contábeis.
                          </p>
                        </div>
                        {dadosEmpresa?.agenda_operador && (
                          <span style={{
                            display: 'inline-block',
                            backgroundColor: '#dc3545',
                            color: 'white',
                            borderRadius: '6px',
                            padding: '6px 12px',
                            fontSize: '0.78rem',
                            fontWeight: '600'
                          }}>
                            <i className="fas fa-calendar-alt me-1"></i>Agendar Reunião Urgente com Assessor
                          </span>
                        )}
                      </div>
                    </div>
                  )}

                  {dadosForm.mensagemAssessor && (
                    <div className="mb-3">
                      <div style={{ backgroundColor: '#f7f9fb', border: '1px solid #dadfe7', padding: '14px 18px', borderRadius: '10px' }}>
                        <h6 style={{ margin: '0 0 10px 0', fontSize: '15px', color: '#1d2530', fontWeight: 'bold' }}>
                          Mensagem do Assessor
                        </h6>
                        {renderMensagemFormatada(dadosForm.mensagemAssessor)}
                        <small className="text-muted d-block mt-1">
                          No e-mail: resumo de 55 palavras + "ver mais" para o Comece Vision.
                        </small>
                      </div>
                    </div>
                  )}

                  {/* Preview Resultado do mês (única linha do DRE que vai no e-mail) */}
                  {!dadosForm.clienteNaoAcesso && (
                    <div className="mb-4">
                      <h6 className="fw-bold mb-2">Resultado do Mês</h6>
                      {resultadoMes.trim() ? (
                        <div className="d-flex justify-content-between align-items-center p-3 rounded border" style={{ background: '#f7f9fb' }}>
                          <div>
                            <small className="text-muted d-block text-uppercase" style={{ fontSize: '0.7rem', letterSpacing: '1px' }}>
                              {resultadoMes.startsWith('-') ? 'Prejuízo do mês' : 'Lucro líquido'}
                            </small>
                            <small className="text-muted">Período de referência: {mesAnoSelecionado}</small>
                          </div>
                          <strong style={{ fontSize: '1.1rem', color: resultadoMes.startsWith('-') ? '#c1153d' : '#196640' }}>
                            R$ {resultadoMes}
                          </strong>
                        </div>
                      ) : (
                        <div className="alert alert-light py-3 text-center">
                          <i className="fas fa-upload fa-2x text-muted mb-2"></i>
                          <p className="mb-0 small text-muted">Faça upload do DRE ou informe o resultado na aba DRE</p>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Preview aviso apuração trimestral IRPJ/CSLL (automático) */}
                  {avisoTrimestralAtivo() && !dadosForm.clienteNaoAcesso && (
                    <div className="mb-4" style={{
                      backgroundColor: '#EBF5FB',
                      border: '1px solid #BEE3F8',
                      borderLeft: '5px solid #2B6CB0',
                      borderRadius: '8px',
                      padding: '18px 22px'
                    }}>
                      <p className="mb-2 fw-bold" style={{ fontSize: '1rem', color: '#1A365D' }}>
                        Apuração Trimestral de IRPJ e CSLL
                      </p>
                      <p className="mb-0" style={{ fontSize: '0.9rem', color: '#2D3748', lineHeight: 1.6 }}>
                        Os valores de IRPJ e CSLL apresentados neste mês são referentes à apuração
                        trimestral do regime tributário da empresa. Para entender a composição desses
                        valores e realizar uma análise mais detalhada, acesse o Comece Vision.
                      </p>
                    </div>
                  )}

                  {/* Preview Distribuição de Lucros */}
                  {retiradasSocios.length > 0 && !dadosForm.clienteNaoAcesso && (
                    <div className="mb-4">
                      <h6 className="fw-bold mb-2">Distribuição de Lucros</h6>
                      <div className="card bg-light">
                        <div className="card-body py-2 px-3">
                          {retiradasSocios.map(item => (
                            <div key={item.id} className="d-flex justify-content-between mb-1">
                              <small>{item.nomeSocio}</small>
                              <small className="fw-bold">R$ {formatarValorMonetario(item.valor)}</small>
                            </div>
                          ))}
                          <div className="border-top pt-1 mt-1">
                            <div className="d-flex justify-content-between">
                              <small className="fw-bold">Total:</small>
                              <small className="fw-bold">
                                R$ {calcularTotalRetiradas().toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Preview Status Entregas */}
                  <div className="mb-4">
                    <h6 className="fw-bold mb-2">Status das Entregas</h6>
                    <div className="row g-2">
                      {camposStatus.map(campo => {
                        const statusAtual = opcoesStatus.find(o => o.valor === statusEntregas[campo.key]);
                        return (
                          <div className="col-6" key={campo.key}>
                            <div className="d-flex align-items-center gap-2 p-2 rounded border bg-white">
                              {statusAtual && <i className={statusAtual.iconClass} style={{ fontSize: '1rem' }}></i>}
                              <div>
                                <small className="text-muted d-block" style={{ fontSize: '0.7rem' }}>{campo.label}</small>
                                <small className="fw-bold" style={{ color: statusAtual?.cor, fontSize: '0.75rem' }}>{statusAtual?.label}</small>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* Preview Pendências */}
                  {pendencias.length > 0 && (
                    <div className="mb-4">
                      <h6 className="fw-bold mb-3">Pendências Identificadas</h6>
                      {pendencias.slice(0, 3).map(pendencia => {
                        const gravidade = opcoesGravidade.find(g => g.valor === pendencia.gravidade);
                        return (
                          <div key={pendencia.id} className={`alert alert-${gravidade.cor} py-2 mb-2`}>
                            <small>{pendencia.descricao}</small>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
                
                <div className="mt-3">
                  <button 
                    className="btn btn-success w-100"
                    onClick={enviarRelatorio}
                    disabled={!dadosEmpresa?.email_socio}
                    style={auditoriaBloqueia ? { opacity: 0.6 } : undefined}
                    title={auditoriaBloqueia ? 'Auditoria pendente: faça a auditoria antes de enviar' : ''}
                  >
                    <i className="fas fa-paper-plane me-2"></i>
                    Enviar Relatório por E-mail
                  </button>
                  
                  {auditoriaBloqueia && (
                    <div className="alert alert-danger mt-2 mb-0 py-2 small">
                      <i className="fas fa-balance-scale me-2"></i>
                      <strong>{auditoria.situacao === 'nunca' ? 'Empresa nunca auditada.' : 'Auditoria vencida.'}</strong>{' '}
                      {auditoria.mensagem}
                    </div>
                  )}

                  {auditoriaAvisa && (
                    <div className="alert alert-warning mt-2 mb-0 py-2 small">
                      <i className="fas fa-balance-scale me-2"></i>
                      {auditoria.mensagem}
                    </div>
                  )}

                  {!dadosEmpresa?.email_socio && (
                    <div className="alert alert-warning mt-2 mb-0 py-2 small">
                      <i className="fas fa-exclamation-triangle me-2"></i>
                      Email do sócio não cadastrado.
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Relatorio_contabil;